const dtGenerator = require('../../../../../components/dt/dt-generator')
const dtHandler = require('../../../../../components/dt/dt-handler')
const dtSearch = require('../../../../../components/dt/dt-search')
const clientPaymentsMenu = require('./clientPayments-menu')
const { organizeRow } = require('./clientPayments-dt-handler')
const { tableDetail } = require('./clientPayments-dt-handler')
const clientPaymentsFetch = require('./clientPayments-fetch')
const settings = require('../../../../../js-handler/settings')
const chart = require('./chart/clientPayments-page-chart')

/****************ELEMENTS*****************/
var htmlDt = {}
var HTMLwasSelected = false

function HTMLselect() {
      dtHandler.HTMLselect('clientPayments-dt', htmlDt, organizeRow, tableDetail)
      HTMLwasSelected = true
}/**/
/****************ELEMENTS*****************/

export function start(detail) {  //console.log('clientPayments-dt 5>', detail)

      console

      if (!HTMLwasSelected) { HTMLselect() }

      obj[detail.act].start(detail)

}/**/

const obj = {

      //From fullcont connection    
      addRow: { start: (detail) => { dtGenerator.addRow(detail, htmlDt) } },
      tableOptions: { start: (detail) => { clientPaymentsMenu.start(detail, htmlDt, 'htmlFc', settings.getData()) } },
      trMenu: { start: (detail) => { clientPaymentsMenu.start(detail, htmlDt, 'htmlFc', settings.getData()) } },
      updateRow: { start: (detail) => { dtGenerator.updateRow(detail, htmlDt) } },
      //data table
      filter: { start: (detail) => { dtSearch.filter(detail, htmlDt) } },
      filterShowHide: { start: (detail) => { dtSearch.filterShowHide(detail, htmlDt) } },
      loadMore: { start: (detail) => { dtSearch.loadMore(detail, htmlDt) } },
      searching: { start: (detail) => { dtSearch.searching(detail, htmlDt) } },
      select: { start: (detail) => { select(detail, htmlDt) } },
      th: { start: (detail) => { dtSearch.th(detail, htmlDt) } },

}/**/

function select(detail, htmlDt) {
      let data;
      dtSearch.select(detail, htmlDt, true, fillChart);
      showCompanyName()

}

function fillChart(result, availableRowsWithFilters, resultComplete){
      const dataChart = JSON.parse(result[0].charts)
      chart.createChart(dataChart)
}

function showCompanyName() {
      const titleAppBar = document.querySelector("#appbar").querySelector("h1");
      titleAppBar.textContent = `${settings.getData().company} - ${settings.getData().name}`;
}